// removed by extract-text-webpack-plugin
module.exports = {"bookmarksPopover":"_2Aj0n","header":"_3QA5w","listWrapper":"_1EbUC","heartLink":"_33WH0","icon":"_3kmKV","popoverBody":"_3ewi_"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/BookmarksPopover/index.sass
// module id = 1464
// module chunks = 1